const state = {
  categoryDetails: {},
};
const mutations = {
  setCategoryDetails(state, categoryDetails) {
    state.categoryDetails = categoryDetails;
  },
};
const getters = {
  categoryDetails(state) {
    return state.categoryDetails;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
